import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "ui vertical masthead center aligned",
  id: "header"
}
const _hoisted_2 = { id: "header-content" }
const _hoisted_3 = { class: "ui inverted header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "admin",
  class: "header-link",
  target: "_blank"
}, "管理后台", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.header), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.subHeader), 1)
    ]),
    _hoisted_4
  ]))
}